import { Component, Inject } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { SystemSetting } from '../../models/system-setting/system-setting.model';
import { SystemSettingService } from '../../services/system-settings/system-setting.service';
import { UtilitiesService } from '../../services/shared/utilities.service';

@Component({
    selector: 'app-setting-list',
    templateUrl: './setting-list.component.html',
    styleUrls: ['./setting-list.component.scss']
})
/** setting-list component*/
export class SettingListComponent {
  public systemSettingList: SystemSetting[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  //Filter items from grid
  filteredItems: any[];
    /** setting-list ctor */
  constructor(private readonly systemSettingService: SystemSettingService, private readonly utilitiesService: UtilitiesService) {
    this.GetSystemSettings();
    this.GetRowsPerPageList();
  }

  GetSystemSettings() {
    this.systemSettingService.GetSystemSettings().subscribe(
      data => {
        this.systemSettingList = data;
        this.filteredItems = data;
      }
    )
  }

  deleteSystemSetting(id) {
    var ans = confirm("Are you sure to delete this system setting? ");
    if (ans) {
      this.systemSettingService.DeleteSystemSetting(id);
      setTimeout(() => {
        this.GetSystemSettings();
      }, 2000);
    }
  }

  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {
    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.systemSettingList, searchText);

    } else {
      this.filteredItems = this.systemSettingList;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/system-setting-component/setting-list/setting-list.component.ts